export default "__VITE_ASSET__814659e5__"